<template>
  <div v-if="isTestEnvironment" class="test-env-container">
    <!-- Top Full Banner Mode -->
    <div v-if="!isMinimized" class="test-env-banner">
      <div class="test-env-content">
        <span class="test-env-badge">
          <span class="pulse-dot"></span>
          🧪 TEST ORTAMI
        </span>
        <span class="test-env-info">
          Bu alan test ortamıdır. İşlemler gerçek verileri etkilemez.
        </span>
        <span class="test-env-detail" v-if="apiHost">
          <strong>API:</strong> {{ apiHost }}
        </span>
        <span class="test-env-detail" v-if="uiHost">
          <strong>UI:</strong> {{ uiHost }}
        </span>
        <span class="test-env-detail" v-if="dbName">
          <strong>DB:</strong> {{ dbName }}
        </span>
        <span class="test-env-detail" v-if="serverLabel">
          <strong>Sunucu:</strong> {{ serverLabel }}
        </span>
      </div>

      <div class="test-env-actions">
        <button class="test-env-btn minimize-btn" @click="isMinimized = true" title="Küçült">
           Küçült
        </button>
      </div>
    </div>

    <!-- Floating Minimized Pill Badge Mode -->
    <div v-else class="test-env-pill" @click="isMinimized = false" title="Test Ortamı Detaylarını Göster">
      <span class="pulse-dot"></span>
      <span>🧪 TEST MODU</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestEnvironmentBanner',
  data() {
    return {
      isMinimized: false
    }
  },
  computed: {
    apiHost() {
      if (!process.env.VUE_APP_ROOT_API) return '';
      try {
        return process.env.VUE_APP_ROOT_API
          .replace(/^(https?:\/\/)?(www\.)?/, '')
          .replace(/\/api\/?$/, '');
      } catch (e) {
        return process.env.VUE_APP_ROOT_API;
      }
    },
    uiHost() {
      if (typeof window === 'undefined') return '';
      return window.location.host;
    },
    dbName() {
      return process.env.VUE_APP_DB_NAME || 'PickPossDB';
    },
    serverLabel() {
      if (process.env.VUE_APP_SERVER_NAME) {
        return process.env.VUE_APP_SERVER_NAME;
      }
      if (typeof window === 'undefined') return 'Lokal';
      const hostname = window.location.hostname.toLowerCase();
      return (hostname === 'localhost' || hostname === '127.0.0.1') ? 'Lokal' : 'Bulut';
    },
    isTestEnvironment() {
      if (typeof window === 'undefined') return false;

      const hostname = window.location.hostname.toLowerCase();
      const isLocal = hostname === 'localhost' || 
                      hostname === '127.0.0.1' || 
                      hostname.startsWith('192.168.') || 
                      hostname.startsWith('10.') || 
                      hostname.endsWith('.local');
      
      const isTestHost = hostname.includes('test') || 
                         hostname.includes('dev') || 
                         hostname.includes('staging') ||
                         hostname.includes('qa');

      const isExplicitTestEnv = process.env.VUE_APP_IS_TEST === 'true' || 
                                process.env.VUE_APP_ENV === 'test' || 
                                process.env.VUE_APP_ENV === 'development';

      const isTestApi = (process.env.VUE_APP_ROOT_API || '').includes('localhost') || 
                        (process.env.VUE_APP_ROOT_API || '').includes('127.0.0.1') || 
                        (process.env.VUE_APP_ROOT_API || '').includes('test') || 
                        (process.env.VUE_APP_ROOT_API || '').includes('dev');

      return isLocal || isTestHost || isExplicitTestEnv || isTestApi;
    }
  }
}
</script>

<style scoped>
.test-env-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  z-index: 999999;
}

/* Üst Sabit Banner */
.test-env-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(90deg, #d97706 0%, #b45309 100%);
  color: #ffffff;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
  font-size: 13px;
  z-index: 999999;
}

.test-env-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.test-env-badge {
  background-color: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background-color: #22c55e;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  animation: pulse-green 1.8s infinite;
}

@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

.test-env-info {
  opacity: 0.95;
}

.test-env-detail {
  background-color: rgba(255, 255, 255, 0.15);
  padding: 2px 8px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 11px;
}

.test-env-actions {
  display: flex;
  align-items: center;
}

.test-env-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: white;
  padding: 2px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.test-env-btn:hover {
  background: rgba(255, 255, 255, 0.35);
}

/* Sağ Alt Küçültülmüş Rozet (Pill) */
.test-env-pill {
  position: fixed;
  bottom: 16px;
  right: 16px;
  background: #d97706;
  color: white;
  padding: 8px 14px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(217, 119, 6, 0.4);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 999999;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.test-env-pill:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(217, 119, 6, 0.5);
}
</style>
